import moment from "moment";

const state = {
  token: null,
  expiry: null
};

const getters = {
  recaptchaToken: (state) => {
    const token = state.token;

    // If we are using the token, ask for a new one
    state.token = null;
    state.expiry = null;

    return token;
  },
};

const mutations = {
  setCaptchaToken(state, token) {
    if (token) {
      state.token = token;
      state.expiry = moment().add(2, 'minutes').toDate()
    } else {
      state.token = null;
      state.expiry = null;
    }
  }
};

const actions = {
  async getCaptchaToken({ getters, state, dispatch }) {
    if (!state.token || moment().isAfter(state.expiry)) {
      await dispatch('generateCaptchaToken');
    }
    return getters.recaptchaToken;
  },

  generateCaptchaToken({ commit }, action) {
    action = action ? action : 'donation';
    console.log('Update reCPATCHA Token => ', action);
    return new Promise((resolve, reject) => {
      try {
        if (grecaptcha) {
          grecaptcha.ready(() => {
            grecaptcha
              .execute(wwfconfigs.RECAPTCHA_KEY, { action })
              .then((token) => {
                commit('setCaptchaToken', token);
                resolve(token);

              }).catch(error => {
                console.error(error);
                reject(err);
              });
          });
        } else {
          return resolve(null);
        }
      } catch (err) {
        return reject(err);
      }
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/recaptcha.js